var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('lodop-print-designer',{ref:"printDesigner",attrs:{"temp-value":_vm.value,"widget-options":_vm.widgets},on:{"save":_vm.handleSave}})}
var staticRenderFns = []

export { render, staticRenderFns }